import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

export class ViewAllBtn extends Component {
  render() {
    const { href, contentData } = this.props;
    return (
      <Link to={href}>
        <button className=' p-[7px_15px] rounded-[50px] font-[700] text-[16px] text-[#fff] bg-[#F05127]'>{contentData?.see_all}</button>
      </Link>
    )
  }
}

const mapStateToProps = (state) => ({
  contentData: state.Data.contentData,
  lang_id: state.Data.lang_id,
})
export default connect(mapStateToProps)(ViewAllBtn)